/**
 * Deep equality check for comparing objects and arrays
 * @param a First value to compare
 * @param b Second value to compare
 * @returns true if values are deeply equal
 */
export function isDeepEqual(a: unknown, b: unknown): boolean {
  if (a === b) return true;

  if (a == null || b == null) return a === b;

  const typeA = typeof a;
  const typeB = typeof b;

  if (typeA !== typeB) return false;

  if (typeA === 'object') {
    const isArrayA = Array.isArray(a);
    const isArrayB = Array.isArray(b);

    if (isArrayA !== isArrayB) return false;

    if (isArrayA && isArrayB) {
      const arr1 = a as unknown[];
      const arr2 = b as unknown[];

      if (arr1.length !== arr2.length) return false;

      return arr1.every((item, index) => isDeepEqual(item, arr2[index]));
    }

    const objA = a as Record<string, unknown>;
    const objB = b as Record<string, unknown>;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) return false;

    return keysA.every((key) => isDeepEqual(objA[key], objB[key]));
  }

  return false;
}
